import { InvoiceRunsState } from './types';
import { ActionTree } from 'vuex';
import { RootState } from '../../types';
import { Logger } from 'fsts';
import { defaultBackendInvoiceRun } from '@/shared/backend/invoiceRun';
import { Value } from '@/shared/model/invoiceRun';
import { AxiosResponse } from 'axios';
import moduleUtils from '../moduleUtils';
import { i18nGlobal } from '@/i18n';

const logger = new Logger('actions.invoiceRuns');
export const actions: ActionTree<InvoiceRunsState, RootState> = {
  getInvoiceRun({ commit }, id: string) {
    return defaultBackendInvoiceRun
      .getInvoiceRun(id)
      .then((resp) => resp.data)
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      });
  },
  getInvoiceRuns(
    { commit, getters },
    payload?: { searchParams?: any; dateFrom?: string; dateTill?: string }
  ) {
    commit('setInvoiceRunsIsLoading', true);
    const searchParams =
      payload?.searchParams ?? getters.getInvoiceRunsSearchParams;

    return defaultBackendInvoiceRun
      .getInvoiceRuns(searchParams, payload?.dateFrom, payload?.dateTill)
      .then((response: AxiosResponse<Value>) => {
        commit('setInvoiceRuns', response.data);
        return response.data;
      })
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      })
      .finally(() => {
        commit('setInvoiceRunsIsLoading', false);
      });
  },
  addExecuteInvoiceRun(
    { commit },
    payload: {
      year: number;
      month: number;
      includeMonthlyInvoices: boolean;
      includeQuarterlyInvoices: boolean;
      includeHalfYearlyInvoices: boolean;
      includeYearlyInvoices: boolean;
    }
  ) {
    commit('setInvoiceRunsIsLoading', true);
    return defaultBackendInvoiceRun
      .addExecuteInvoiceRun(
        payload.year,
        payload.month,
        payload.includeMonthlyInvoices,
        payload.includeQuarterlyInvoices,
        payload.includeHalfYearlyInvoices,
        payload.includeYearlyInvoices
      )
      .then((resp) => {
        moduleUtils.ok(i18nGlobal.t(`success.invoice_run_execution`), commit);
        return resp.data;
      })
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      })
      .finally(() => {
        commit('setInvoiceRunsIsLoading', false);
      });
  },
  deleteInvoiceRun({ commit }, id: string) {
    commit('setInvoiceRunsIsLoading', true);
    return defaultBackendInvoiceRun
      .deleteInvoiceRun(id)
      .then(() => {
        moduleUtils.ok(i18nGlobal.t(`success.invoice_run_deletion`), commit);
      })
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      })
      .finally(() => {
        commit('setInvoiceRunsIsLoading', false);
      });
  },
};
